export default __webpack_public_path__ + "static/media/avisverifie.51e47d7f.png";